export default "__VITE_ASSET__cc33c7ca__"